import React, { memo } from 'react';

const HeaderTitle = ({ title }) => (
  <h1 className="weight--medium title--xl title-page">
    {title}
  </h1>
);

export default memo(HeaderTitle);
